(() => {
  if (window.ksHomeProgress) return;
  window.ksHomeProgress = true;
  let busy = false;
  function unavailable(target) {
    target.querySelector('.ksp-meter')?.setAttribute('hidden', '');
    const component = target.querySelector('ks-progress-option');
    const detail = component?.querySelector('[data-ksp-detail]');
    if (detail) { detail.textContent = target.dataset.error; detail.hidden = false; }
    const note = component?.querySelector('[data-ksp-note]');
    if (note) note.hidden = true;
  }
  async function refresh() {
    if (busy || document.hidden) return;
    const targets = [...document.querySelectorAll('[data-home-drop]')];
    if (!targets.length) return;
    busy = true;
    try {
      const ids = [...new Set(targets.map(target => target.dataset.sectionId).filter(Boolean))];
      targets.filter(target => !target.dataset.sectionId).forEach(unavailable);
      const batches = [];
      for (let i = 0; i < ids.length; i += 5) batches.push(ids.slice(i, i + 5));
      await Promise.all(batches.map(async batch => {
        const members = targets.filter(target => batch.includes(target.dataset.sectionId));
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 10000);
        try {
          const url = new URL(location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', batch.join(','));
          url.searchParams.set('_reservation', Date.now());
          const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw Error('counter');
          const sections = await response.json();
          for (const target of members) {
            try {
              const html = sections[target.dataset.sectionId];
              if (typeof html !== 'string') throw Error('counter');
              const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-home-drop-content]');
              const old = target.querySelector('[data-home-drop-content]');
              if (!fresh || !old) throw Error('counter');
              old.replaceWith(fresh);
            } catch { unavailable(target); }
          }
        } catch { members.forEach(unavailable); }
        finally { clearTimeout(timer); }
      }));
    } finally { busy = false; }
  }
  setInterval(refresh, 30000);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
